import { FC, useContext, useEffect, useRef, useState } from "react";
import { Modal } from "@app/shared/Modals";
import ExceptionsService from "./exceptionsService";
import { toast } from "react-toastify";
import { ExceptionsFiltersContext } from "./contexts/ExceptionsFiltersContext";

interface ArchiveExceptionsModalProps {
  isModalOpen: boolean;
  setIsModalOpen: (isOpen: boolean) => void;
  singleExceptionId?: number
  resetSelectedCheckboxes: () => void;
}

const ArchiveExceptionsModal: FC<ArchiveExceptionsModalProps> = ({ isModalOpen, setIsModalOpen, singleExceptionId, resetSelectedCheckboxes }) => {

  const exceptionsService = useRef(new ExceptionsService()).current;
  const exceptionFilterContext = useContext(ExceptionsFiltersContext);
  const [bodyMessage, setBodyMessage] = useState<string>("");
 

  useEffect(() => {
    if (exceptionFilterContext.selectedExceptionIds.length == 1 || singleExceptionId) {
      setBodyMessage("1 exception has been selected to be archived. Do you wish to continue?");
    } else {
      setBodyMessage(`${exceptionFilterContext.selectedExceptionIds.length} exceptions have been selected to be archived. Do you wish to continue?`);
    }
  }, [exceptionFilterContext.selectedExceptionIds, singleExceptionId]);

  const archiveExceptions = async () => {
    let successfullMessage = "";
    try {
      if (singleExceptionId) {
        await exceptionsService.archiveExceptions([singleExceptionId]);
        successfullMessage = "The selected exception has been successfully archived";
      } else {
        const selectedExceptionIds = exceptionFilterContext.selectedExceptionIds;
        await exceptionsService.archiveExceptions(selectedExceptionIds);
        successfullMessage = selectedExceptionIds.length > 1 ? "The selected exceptions have been successfully archived" : "The selected exception has been successfully archived";
      }                      
          
      toast(successfullMessage,
        {
          containerId: "z-index-9999",
          type: "success"
        }
      );
    }
    catch (error) {
      toast.error("There was an error archiving the exception(s).");
    }
    finally {
      exceptionFilterContext.reloadFilters(); 
      exceptionFilterContext.setTriggerRefreshData(true);
      setIsModalOpen(false);
      resetSelectedCheckboxes();
    }
  }

  const closeModal = () => {
    setIsModalOpen(false);
  }

  return (
    <Modal
      closeModal={closeModal}
      content={{
        body: (
          <div className="ps-3 pe-3 mb-3">
            {bodyMessage}
          </div>
        ),
        cancelButtonText: "Cancel",
        confirmButtonAction: archiveExceptions,
        confirmButtonText: "Continue",
        confirmButtonType: "primary",
        title: (singleExceptionId != undefined || exceptionFilterContext.selectedExceptionIds.length == 1) ? 'Archive Exception' : 'Archive Exceptions'
      }}
      isVisible={isModalOpen}
      hideBodyScroll={true}
    />
  );
}

export default ArchiveExceptionsModal;
